import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Apartment from "./components/apartment/Apartment";
import { BrowserRouter, Route, Router, Routes } from "react-router-dom";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    
   
    <Routes>
      <Route path="/" element={<App />}></Route>
      <Route path="/apartment" element={<Apartment />} />
    </Routes>
  </BrowserRouter>
);
